export default {
    "palette": {
        "primary": {
            "main": "#10bab3",
            "contrastText": "#ffffff"
        },
        "secondary": {
            "main": "#42454a"
        },
        "type": "dark"
    },
    "googleFonts": [
        "Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic"
    ],
    "typography": {
        "fontFamily": "Roboto",
        "h6": {
            "fontWeight": 400
        }
    }
};